import { useCallback, useState } from 'react'
import { supabase } from '../../shared/lib/supabase'

async function createRenewalTerm(clientId, previousTerm) {
  const today = new Date().toISOString().slice(0, 10)
  const oneYearOut = new Date()
  oneYearOut.setFullYear(oneYearOut.getFullYear() + 1)
  const { data, error } = await supabase
    .from('client_insurance_policy_terms')
    .insert({
      client_id: clientId,
      status: 'active',
      layer_type: previousTerm?.layer_type || 'single',
      effective_date: today,
      expiration_date: oneYearOut.toISOString().slice(0, 10),
      carrier: previousTerm?.carrier || null,
      policy_label: previousTerm?.policy_label ? `${previousTerm.policy_label} (renewal)` : null,
      notes: 'Created via Run New Review · renewal'
    })
    .select('id')
    .single()
  if (error) throw new Error(`Failed to create renewal term: ${error.message}`)
  // Mark previous term expired
  if (previousTerm?.id) {
    await supabase
      .from('client_insurance_policy_terms')
      .update({ status: 'expired' })
      .eq('id', previousTerm.id)
  }
  return data.id
}

export default function useRunNewReview({ clientId, currentReview, currentTerm, onStarted } = {}) {
  const [isOpen, setIsOpen] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  const submit = useCallback(async ({ kind }) => {
    if (!clientId || submitting) return
    setSubmitting(true)
    try {
      const policyTermId = kind === 'renewal'
        ? await createRenewalTerm(clientId, currentTerm)
        : currentTerm?.id
      onStarted?.({
        review_kind: kind,
        parent_review_id: currentReview?.id || null,
        policy_term_id: policyTermId
      })
      setIsOpen(false)
    } catch (err) {
      console.error('[run-new-review] submit failed:', err)
      alert(err.message || 'Failed to start new review')
    } finally {
      setSubmitting(false)
    }
  }, [clientId, currentReview, currentTerm, onStarted, submitting])

  return { open, close, submit, isOpen, submitting }
}
